import { FEATURES } from "./constants";

export const FeaturesSection = () => (
  <section id="features" className="features" data-testid="features-section">
    <div className="section-head reveal">
      <div className="section-eyebrow">Why KIRA Markets</div>
      <h2 className="section-title">
        Six modules of <span className="gold">educational analytics</span>.
      </h2>
    </div>
    <div className="feature-grid">
      {FEATURES.map((f, i) => (
        <div
          className="feature-card reveal"
          key={f.title}
          style={{ transitionDelay: `${i * 60}ms` }}
          data-testid={`feature-${i}`}
        >
          <div className="feature-icon">{f.icon}</div>
          <div className="feature-title">{f.title}</div>
          <div className="feature-desc">{f.desc}</div>
        </div>
      ))}
    </div>
  </section>
);
